module.exports = __webpack_public_path__ + "media/images/landing/home/categories/base-ff193d23e0242cdb183cac11cb02d340.png";